(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["boka-x-fishem-collab"] && !Shopify.designMode) return;
  try {
    
  const correctAnswer = "gnamgnam";
  function checkAnswer() {
            const inputs = document.querySelectorAll('.word-container .letter input');
            let userAnswer = '';
            inputs.forEach(input => {
                userAnswer += input.value;
            });
            if(userAnswer.length  === correctAnswer.length )
            {
              if (userAnswer.toLowerCase() === correctAnswer)
              {
                document.getElementById('popup-correct').style.opacity = 1;
                //document.getElementById('popup-correct').style.display = 'block';
                //document.getElementById('popup-wrong').style.display = 'none';

              }
              else{
                document.getElementById('popup-wrong').style.opacity = 1;
                //document.getElementById('popup-wrong').style.display = 'block';
                //document.getElementById('popup-correct').style.display = 'none';
              }
            }
            else{
              document.getElementById('popup-correct').style.opacity = 0;
              document.getElementById('popup-wrong').style.opacity = 0;
            }


        }


        function containsInputElement(element) {
            return element.querySelector('input') !== null;
        }

        function getNextInputElement(element) {
            let nextElement = element.nextElementSibling;
            while (nextElement) {
                if (containsInputElement(nextElement)) {
                    return nextElement.querySelector('input');
                }
                nextElement = nextElement.nextElementSibling;
            }
            return null;
        }

        function getPreviousInputElement(element) {
            let prevElement = element.previousElementSibling;
            while (prevElement) {
                if (containsInputElement(prevElement)) {
                    return prevElement.querySelector('input');
                }
                prevElement = prevElement.previousElementSibling;
            }
            return null;
        }

        document.querySelectorAll('.letter-input').forEach(input => {
                input.addEventListener('input', (event) => {
                if (input.value.length > 1) {
                    input.value = input.value[0];
                }
                if (input.value.length > 0) {
                    let nextInput = getNextInputElement(input.parentElement);
                    if (nextInput) {
                        nextInput.focus();
                    }
                } else if (input.value.length === 0 && event.inputType === 'deleteContentBackward') {
                    let prevInput = getPreviousInputElement(input.parentElement);
                    if (prevInput) {
                        prevInput.focus();
                    }
                }
                checkAnswer();
            });


                input.addEventListener('keydown', (event) => {
                  event.preventDefault(); // Prevent the default behavior of adding the character
                if (event.key.length === 1 && event.key !== 'Backspace') {

                    input.value = event.key.toUpperCase();
                    let nextInput = getNextInputElement(input.parentElement);
                    if (nextInput) {
                        nextInput.focus();
                    }
                } else if (event.key === 'Backspace' && input.value.length === 1) {
                  input.value = '';
                }

                else if (event.key === 'Backspace' && input.value.length === 0) {
                    let prevInput = getPreviousInputElement(input.parentElement);
                    if (prevInput) {
                        prevInput.focus();
                    }
                }
                checkAnswer();
            });
        });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["chalet-dei-marinai-x-fishem-collab"] && !Shopify.designMode) return;
  try {
    
  const correctAnswer = "ilovefishem";
  function checkAnswer() {
            const inputs = document.querySelectorAll('.word-container .letter input');
            let userAnswer = '';
            inputs.forEach(input => {
                userAnswer += input.value;
            });
            if(userAnswer.length  === correctAnswer.length )
            {
              if (userAnswer.toLowerCase() === correctAnswer)
              {
                document.getElementById('popup-correct').style.opacity = 1;
                //document.getElementById('popup-correct').style.display = 'block';
                //document.getElementById('popup-wrong').style.display = 'none';

              }
              else{
                document.getElementById('popup-wrong').style.opacity = 1;
                //document.getElementById('popup-wrong').style.display = 'block';
                //document.getElementById('popup-correct').style.display = 'none';
              }
            }
            else{
              document.getElementById('popup-correct').style.opacity = 0;
              document.getElementById('popup-wrong').style.opacity = 0;
            }


        }


        function containsInputElement(element) {
            return element.querySelector('input') !== null;
        }

        function getNextInputElement(element) {
            let nextElement = element.nextElementSibling;
            while (nextElement) {
                if (containsInputElement(nextElement)) {
                    return nextElement.querySelector('input');
                }
                nextElement = nextElement.nextElementSibling;
            }
            return null;
        }

        function getPreviousInputElement(element) {
            let prevElement = element.previousElementSibling;
            while (prevElement) {
                if (containsInputElement(prevElement)) {
                    return prevElement.querySelector('input');
                }
                prevElement = prevElement.previousElementSibling;
            }
            return null;
        }

        document.querySelectorAll('.letter-input').forEach(input => {
                input.addEventListener('input', (event) => {
                if (input.value.length > 1) {
                    input.value = input.value[0];
                }
                if (input.value.length > 0) {
                    let nextInput = getNextInputElement(input.parentElement);
                    if (nextInput) {
                        nextInput.focus();
                    }
                } else if (input.value.length === 0 && event.inputType === 'deleteContentBackward') {
                    let prevInput = getPreviousInputElement(input.parentElement);
                    if (prevInput) {
                        prevInput.focus();
                    }
                }
                checkAnswer();
            });


                input.addEventListener('keydown', (event) => {
                  event.preventDefault(); // Prevent the default behavior of adding the character
                if (event.key.length === 1 && event.key !== 'Backspace') {

                    input.value = event.key.toUpperCase();
                    let nextInput = getNextInputElement(input.parentElement);
                    if (nextInput) {
                        nextInput.focus();
                    }
                } else if (event.key === 'Backspace' && input.value.length === 1) {
                  input.value = '';
                }

                else if (event.key === 'Backspace' && input.value.length === 0) {
                    let prevInput = getPreviousInputElement(input.parentElement);
                    if (prevInput) {
                        prevInput.focus();
                    }
                }
                checkAnswer();
            });
        });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-list-slider-fishem"] && !Shopify.designMode) return;
  try {
    

  function createSlider(containerItem, sliderSelector, itemSelector, paddingSpacing){
    const slider = containerItem.querySelector(sliderSelector);
    const items = slider.querySelectorAll(itemSelector);
    const events = ['mousedown', 'mouseleave', 'mouseup', 'mousemove', 'touchstart', 'touchend', 'touchmove'];
    const padding_spacing = paddingSpacing;
        
    let startX;
    let currentOffset = 0;
        let maxOffset = computeMaxOffset();
    let moved = false;
    let isActive = false;
    let isDown = false;
  
    function addEventListeners() {
      for (const event of events) {
        slider.addEventListener(event, handleEvent);
      }
      for (const item of items) {
        item.addEventListener('click', avoidAnchorClick);
      }
      window.addEventListener('resize',onResize);
    }
  
    function computeMaxOffset(){
              return window.innerWidth - slider.scrollWidth - 2*window.innerWidth*padding_spacing/100;
          }
  
        
    function onResize(){
      maxOffset = computeMaxOffset();
          if(mightBeInViewport(slider))
              {
                  isActive = false;
                  containerItem.style.display = "flex";
                  containerItem.style.justifyContent = "center";
                  slider.style.cursor = 'auto';
                  resetPosition(0);
              } 
              else{
                isActive = true;
                  containerItem.style.display = "block";
              }
      }
  
    function getPositionX(event) {
      return event.type.includes('mouse') ? event.pageX : event.targetTouches[0].clientX;
    }
  
    function avoidAnchorClick(e) {
      if (moved) {
        e.preventDefault();
        e.stopPropagation();
        moved = false;
      }
    }
  
    function engage(e) {
      if(!isActive) return;
      isDown = true;
      slider.style.cursor = 'grabbing';
      startX = getPositionX(e) - currentOffset;
    }
  
    function disengage(e) {
      if(!isActive) return;
      isDown = false;
      slider.style.cursor = 'grab';
      if (e.type.includes('touch')) {
        moved = false;
      }
      if (currentOffset > 0) resetPosition(0);
      if (currentOffset < maxOffset) resetPosition(maxOffset);
    }
  
    function move(e) {
      if (!isDown) return;
      if (isInViewport(slider)) return;
      e.preventDefault();
      moved = true;
      currentOffset = getPositionX(e) - startX;
      //slider.style.transform = `translateX(${currentOffset}px)`;
      slider.style.webkitTransform = `translateX(${currentOffset}px)`;
    }
  
    function resetPosition(position) {
              currentOffset = position;
              //slider.style.transform = `translateX(${currentOffset}px)`;
              slider.style.webkitTransform = `translateX(${currentOffset}px)`;
          }
  
   function mightBeInViewport(element){
            return (element.scrollWidth <= (window.innerWidth || document.documentElement.clientWidth));
        }
    function isInViewport(element) {
          const rect = element.getBoundingClientRect();
          return (
              rect.top >= 0 &&
              rect.left >= 0 &&
              rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
              rect.right <= (window.innerWidth || document.documentElement.clientWidth)
          );
      }
  
    function handleEvent(e) {
      switch (e.type) {
        case 'mousedown':
        case 'touchstart':
          engage(e);
          break;
        case 'mouseleave':
        case 'mouseup':
        case 'touchend':
          disengage(e);
          break;
        case 'mousemove':
        case 'touchmove':
          move(e);
          break;
      }
    }
  
    addEventListeners();
    onResize()
  }
  const containers = document.querySelectorAll('.collection-list-slider-fishem__content');
  for (const container of containers) {
    createSlider(container,'.collection-list-slider__collections-fishem', '.collection-item-fishem', 3.3);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["form-to-pdf"] && !Shopify.designMode) return;
  try {
    
  const form = document.querySelector('.contact-form__form');
  const submit_button = document.querySelector('.contact-form__button');
  submit_button.addEventListener('click', callbackFunction);
  //Sostituire con click
  //form.addEventListener('submit', callbackFunction);

  var canvas = document.getElementById('signature');
  var signature = document.getElementsByName('signature')[0];
  const clearButton = document.getElementById('clearButton');
  canvas.width = 500; // Drawing surface width in pixels
  canvas.height = 100; // Drawing surface height in pixels

  const canvas_events = ['mousedown', 'mouseup', 'mousemove', 'touchstart', 'touchend', 'touchmove'];


  //Canvas settingss
  const ctx = canvas.getContext('2d');
  let drawing = false;
  let prevX = 0;
  let prevY = 0;



  function addEventListeners() {
      for (const event of canvas_events) {
        canvas.addEventListener(event, handleEvent);
      }
      clearButton.addEventListener('click',clearSignature)
    }

  function getMousePos(event) {
      const rect = canvas.getBoundingClientRect(); // Get the actual size of the canvas on the screen
      const scaleX = canvas.width / rect.width;    // Compute the horizontal scaling factor
      const scaleY = canvas.height / rect.height;  // Compute the vertical scaling factor
      x_temp = 0;
      y_temp = 0;
      if(event.type == 'touchstart' || event.type == 'touchmove'){
        x_temp = event.touches[0].clientX;
        y_temp = event.touches[0].clientY;
      }
      else{
        x_temp = event.clientX;
        y_temp = event.clientY;
      }

      const x = (x_temp - rect.left) * scaleX;
      const y = (y_temp - rect.top) * scaleY;
      return { x, y };
  }

  function start(e){
      drawing = true;
      const pos = getMousePos(e);
      prevX = pos.x;
      prevY = pos.y;
  }

  function draw(e){
    if (drawing) {
          const pos = getMousePos(e);
          const currX = pos.x;
          const currY = pos.y;
          drawLine(prevX, prevY, currX, currY);
          prevX = currX;
          prevY = currY;
      }
  }

    function stop(e){
      signature.value = canvas.toDataURL();
      drawing = false;
    }

  // canvas.addEventListener('mouseleave', () => {
  //     drawing = false;
  // });

  function drawLine(prevX, prevY, currX, currY) {
      ctx.beginPath();
      ctx.moveTo(prevX, prevY);
      ctx.lineTo(currX, currY);
      ctx.strokeStyle = 'black';
      ctx.lineWidth = 2;
      ctx.stroke();
      ctx.closePath();
  }

  function clearSignature(e){
      e.preventDefault();
      ctx.clearRect(0, 0, canvas.width, canvas.height);
  }


   function handleEvent(e) {
     e.preventDefault();
      switch (e.type) {
        case 'mousedown':
        case 'touchstart':
          start(e);
          break;
        case 'mouseup':
        case 'touchend':
          stop(e);
          break;
        case 'mousemove':
        case 'touchmove':
          draw(e);
          break;
      }
   }


  function callbackFunction(event) {
      event.preventDefault();
      const myFormData = new FormData(form);
      const formDataObj = {};
      myFormData.forEach((value, key) => (formDataObj[key] = value));
      console.log(formDataObj);
      fetch(
        'https://api.fishem.it/api/form/acquisto-privati',
          {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(formDataObj),
    })
        .then(response => {
          // Check if the request was successful
          if (response.ok) {
            // Parse the response as HTML
            return response.json();
          } else {
            return {"success": false, "error": "Failed to send data"};
          }
        })
        .then(data => {
          // Log the parsed HTML
          console.log(data);
          if(data.success === true){
            form.submit();

          }
          else{
            console.log(data.error);
            alert(data.error);
          }
        }).catch(error => {
    alert('There was an error submitting the form. Please try again later.');
  });
    }

     addEventListeners()

  } catch(e) { console.error(e); }
})();
})();
